var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconObject = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4264FD",
  d: "m24.71 13.76-2-6a.74.74 0 0 0-.71-.51H8c-.32 0-.61.21-.71.51l-2 6a.75.75 0 0 0 .1.68c.14.2.37.31.61.31h1.25V23c0 .41.34.75.75.75h14c.41 0 .75-.34.75-.75v-8.25H24c.24 0 .47-.12.61-.31s.18-.45.1-.68m-13.67-.51 1.5-4.5h1.71v4.5zm4.71-4.5h1.71l1.5 4.5h-3.21zm-7.21 0h2.42l-1.5 4.5H7.04zm4.21 13.5V21c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v1.25zm8.5 0h-2.5V21c0-2.07-1.68-3.75-3.75-3.75s-3.75 1.68-3.75 3.75v1.25h-2.5v-7.5h12.5zm.75-9h-1.46l-1.5-4.5h2.42l1.5 4.5z"
})));
export default SvgIconObject;